/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalUserStatus } from './ExternalUserStatus';
import {
    ExternalUserStatusFromJSON,
    ExternalUserStatusFromJSONTyped,
    ExternalUserStatusToJSON,
    ExternalUserStatusToJSONTyped,
} from './ExternalUserStatus';

/**
 * 
 * @export
 * @interface ExternalUserStatusUpdateRequest
 */
export interface ExternalUserStatusUpdateRequest {
    /**
     * 
     * @type {ExternalUserStatus}
     * @memberof ExternalUserStatusUpdateRequest
     */
    status?: ExternalUserStatus;
}



/**
 * Check if a given object implements the ExternalUserStatusUpdateRequest interface.
 */
export function instanceOfExternalUserStatusUpdateRequest(value: object): value is ExternalUserStatusUpdateRequest {
    return true;
}

export function ExternalUserStatusUpdateRequestFromJSON(json: any): ExternalUserStatusUpdateRequest {
    return ExternalUserStatusUpdateRequestFromJSONTyped(json, false);
}

export function ExternalUserStatusUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalUserStatusUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : ExternalUserStatusFromJSON(json['status']),
    };
}

export function ExternalUserStatusUpdateRequestToJSON(json: any): ExternalUserStatusUpdateRequest {
    return ExternalUserStatusUpdateRequestToJSONTyped(json, false);
}

export function ExternalUserStatusUpdateRequestToJSONTyped(value?: ExternalUserStatusUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': ExternalUserStatusToJSON(value['status']),
    };
}

